import { useState } from "react";

interface PdfGuideProps {
  pdfUrl: string;
  title?: string;
}

export function PdfGuide({ pdfUrl, title }: PdfGuideProps): JSX.Element {
  const [showInline, setShowInline] = useState<boolean>(false);

  return (
    <div className="pdf-guide">
      <h2>{title}</h2>
      {!showInline && (
        <div className="pdf-preview">
          <div className="pdf-actions">
            <button
              type="button"
              onClick={() => setShowInline(true)}
              className="pdf-btn"
            >
              Read here
            </button>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-btn pdf-btn-secondary"
            >
              Open in new tab
            </a>
            <a href={pdfUrl} download className="pdf-btn pdf-btn-secondary">
              Download
            </a>
          </div>
        </div>
      )}

      {showInline && (
        <div className="pdf-embed-wrapper">
          <button
            type="button"
            onClick={() => setShowInline(false)}
            className="pdf-btn pdf-close"
          >
            Close
          </button>
          <object
            data={pdfUrl}
            type="application/pdf"
            width="100%"
            height="800px"
          >
            <p>
              Your browser can't display PDFs inline.{" "}
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                Open the guide here
              </a>
              .
            </p>
          </object>
        </div>
      )}
    </div>
  );
}
